import styled from 'styled-components';

const MyDiv = styled.div`
  .chart-container {
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.06);
  }

  .donut-chart {
    width: 120px;
    height: 120px;
  }

  .legend-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 8px;
  }

  .legend-row {
    width: 100%;
  }

  .color-box {
    width: 12px;
    height: 12px;
    border-radius: 2px;
  }
`;

export default MyDiv;
